import { getFormatMessage } from '@/utils/utils'
import React, { useEffect, useState } from 'react'
import { BoxJob } from '.'
import { BoxJobItem, BoxJobListProps, BoxJobProps } from '../interface'

export const BoxJobList: React.FC<BoxJobListProps> = (
  props: BoxJobListProps
) => {
  const [options, setOptions] = useState<any[]>([])
  const [search, setSearch] = useState<{ state: number }>({ state: 1 })
  const [total, setTotal] = useState<number>(0)
  const [items, setItems] = useState<BoxJobItem[]>([])
  const [defaultPageSize, setDefaultPageSize] = useState<number>(10)

  const { states, size, progressItem, onItemLoad } = props
  const formatMessage = getFormatMessage()
  const jobProps: BoxJobProps = {
    pagination: {
      total: total,
      pageSize: defaultPageSize,
      onChange: async (pageNumber: number, pageSize?: number) => {
        const skip = (pageNumber - 1) * (pageSize || defaultPageSize)
        await loadJobs(skip, pageSize || defaultPageSize, search.state)
      },
      onShowSizeChange: async (pageNumber: number, pageSize: number) => {
        setDefaultPageSize(pageSize)
        const skip = (pageNumber - 1) * pageSize
        await loadJobs(skip, pageSize, search.state)
      }
    },

    onSearch: async (args: { state: number }) => {
      if (args.state !== search.state) {
        setSearch(args)
        await loadJobs(0, 10, args.state)
        setDefaultPageSize(10)
      }
    }
  }

  const loadJobs = async (skip: number, take: number, state: number) => {
    if (onItemLoad) {
      const resp = await onItemLoad?.(skip, take, { state: state })
      setTotal(resp.totalCount)
      setItems(resp.items)
    }
  }

  const loadState = async () => {
    if (states == null) return
    const opt =
      states?.map((x) => ({
        label:
          formatMessage({ id: `app.box.job.state.${x.state}` }) +
          `(${x.count})`,
        value: x.state
      })) || []
    setOptions(opt)
    if (opt.length > 0) {
      const item = states.find((x) => x.default === true)
      const defaultState = item ? item.state! : states[0].state!
      setSearch({ state: defaultState })
      await loadJobs(0, 10, defaultState)
    }
  }

  useEffect(() => {
    loadState()
  }, [states])

  useEffect(() => {
    if (progressItem) {
      const newItems = items.map((x) => {
        if (x.id == progressItem.id) {
          x.progress = progressItem.progress
        }
        return x
      })
      setItems(newItems)
    }
  }, [progressItem])

  return (
    <BoxJob
      {...jobProps}
      data={items}
      options={options}
      state={search.state}
      size={size || 'middle'}
    />
  )
}
